import { apiRequest } from "./api";
import { fromReturnResponse } from "./trucksService.js";

// Maps the wizard's amendVehicles row shape ({ id, vin, oldCat, newCat, logging })
// onto the backend's AmendVehicleRequest shape.
function toAmendVehicleRequestBody({ vin, oldCat, newCat, logging }) {
  return {
    vin,
    oldCategoryCd: oldCat,
    newCategoryCd: newCat,
    isLogging: !!logging,
  };
}

// Maps the wizard's correctedVins row shape ({ oldVin, vin, cat, logging, suspended })
// onto the backend's VinCorrectionRequest shape.
function toVinCorrectionRequestBody({ oldVin, vin, cat, logging, suspended }) {
  return {
    oldVin,
    vin,
    categoryCd: suspended ? "W" : cat,
    isLogging: !!logging,
    isSuspended: !!suspended,
  };
}

// PATCH /returns/{returnId} -> update the tax year and/or first-used month;
// totals are recomputed server-side and returned. Used by the Tax year
// field on each filing form (Trucks, VIN Correction, Amended - mileage
// reason), which (unlike TrucksStep's own Month field) needs to save both
// fields together.
export async function updateReturnYearMonth(returnId, { taxYear, firstUsedMonth }) {
  const data = await apiRequest(`/returns/${returnId}`, {
    method: "PATCH",
    body: { taxYear, firstUsedMonth },
  });
  return fromReturnResponse(data);
}

// PATCH /returns/{returnId}/form-type -> saves the filing type, address-change
// flag, and (depending on filing type) the amendment reason/month/vehicles or
// the VIN-correction explanation/corrected vehicles - one call for the whole
// Form / Amended Return / Weight Increase / Mileage Exceeded / VIN Correction
// cluster, matching how the backend already models it as one PATCH.
export async function saveFormType(returnId, {
  returnType,
  addressChange,
  amendReason,
  amendMonth,
  amendMonthMileage,
  vinCorrectionExpl,
  amendVehicles,
  correctedVins,
  taxPreparerId,
}) {
  const data = await apiRequest(`/returns/${returnId}/form-type`, {
    method: "PATCH",
    body: {
      formTypeCd: returnType,
      addrChangeInd: !!addressChange,
      amendReasonCd: amendReason || null,
      amendMonthWeight: amendMonth || null,
      amendMonthMileage: amendMonthMileage || null,
      vinCorrectionExpl: vinCorrectionExpl || null,
      amendVehicles: (amendVehicles || []).map(toAmendVehicleRequestBody),
      vinCorrections: (correctedVins || []).map(toVinCorrectionRequestBody),
      taxPreparerId: taxPreparerId || null,
    },
  });
  return fromReturnResponse(data);
}
